const IS_DEVELOPER = true;

const LOCAL_URL_HEAD = 'http://myapi.local:5010/';
const DEV_URL_HEAD = 'https://flabs-test.fluxionsolution.com/';
const PAYMET_HEAD = 'https://fluxion-cdfpcve0h5hdakc7.eastus-01.azurewebsites.net/';

const development = IS_DEVELOPER;

const defaultBaseUrl = development ? DEV_URL_HEAD : LOCAL_URL_HEAD;

/** Live binding: importers read the current value when each request runs. */
export let BASE_URL = defaultBaseUrl;

export const PAYMENT_HEADER = PAYMET_HEAD;
export const BASE_URL1 = undefined;

const STORAGE_BASE_KEY = 'api_base_url_override';

function normalizeBaseUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim().replace(/\/+$/, '');
  return trimmed ? `${trimmed}/` : '';
}

export function setRuntimeBaseUrl(url) {
  const n = normalizeBaseUrl(url);
  if (!n) return;
  BASE_URL = n;
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_BASE_KEY, BASE_URL);
    }
  } catch (_) {}
}

export function resetBaseUrlToLocalDefault() {
  BASE_URL = defaultBaseUrl;
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(STORAGE_BASE_KEY);
    }
  } catch (_) {}
}

export function syncBaseUrlFromLocalStorage() {
  try {
    if (typeof localStorage === 'undefined') return;
    const o = localStorage.getItem(STORAGE_BASE_KEY);
    if (o) {
      const n = normalizeBaseUrl(o);
      if (n) BASE_URL = n;
    }
  } catch (_) {}
}

/** Call on app start (Electron + browser) so API base survives refresh. */
export async function applyPersistedBaseUrl() {
  try {
    if (
      typeof window !== 'undefined' &&
      window.process &&
      window.process.type === 'renderer'
    ) {
      const { ipcRenderer } = window.require('electron');
      const mode = await ipcRenderer.invoke('store-get', 'login_mode');
      if (mode === 'cloud') {
        const url = await ipcRenderer.invoke('store-get', 'api_base_url');
        if (url && typeof url === 'string') {
          setRuntimeBaseUrl(url);
          return;
        }
      }
    }
  } catch (_) {}
  syncBaseUrlFromLocalStorage();
}

syncBaseUrlFromLocalStorage();

export const GET_VERSION = 'api/0102/getAppVersion';
export const LOGIN = 'api/0102/getAuthenticated';

export const POST_MASTER_DATA = 'api/0202/postMasterData';
export const GET_MASTER_DATA = 'api/0202/getMasterData';
export const PUT_MASTER_DATA = 'api/0202/putMasterData';
export const POST_ITEM_MASTER = 'api/0202/postItemMaster';
export const GET_ITEM_MASTER = 'api/0202/getItemMaster'; 
export const PUT_ITEM_MASTER = 'api/0202/putItemMaster';
export const DELETE_ITEM_MASTER = 'api/0202/deleteItemMaster';
export const STATUS_CHANGE = 'api/0202/InactiveItemMaster';

export const GET_SUPPLIER_MASTER = 'api/0202/getSupplierMaster';
export const POST_SUPPLIER_MASTER = 'api/0202/postSupplierMaster';
export const PUT_SUPPLIER_MASTER = 'api/0202/putSupplierMaster';
export const DELETE_SUPPLIER_MASTER = 'api/0202/deleteSupplierMaster';
export const TOGGLE_SUPPLIER_STATUS = 'api/0202/toggleSupplierStatus';
export const POST_SUPPLIER_MAPPING = 'api/0303/supplierMapping';
export const GET_SUPPLIER_DUEBILLS = 'api/0203/getSupplierOverDueBills';
export const POST_SUPPLIER_PAYMENT = 'api/0203/postPaymentEntry';

export const POST_PURCHASE_TRANSACTION = 'api/0203/postPurchaseTransaction';
export const GET_BASE_DATA = 'api/0203/getPurchasePageLoadDataset';

export const GET_MANUFACTURER_MASTER = 'api/0202/getManufactureData';
export const POST_MANUFACTURER_MASTER = 'api/0202/postManufactureData';
export const PUT_MANUFACTURER_MASTER = 'api/0202/putManufactureData';

export const GET_PATIENTS = 'api/0202/getPatientMaster';
export const POST_PATIENT = 'api/0202/postPatientMaster';
export const PUT_PATIENT = 'api/0202/putPatientMaster';
export const GET_PATIENT_TRACK = 'api/9989/getPatientInfo';
export const GET_PATIENT_HISTORY = 'api/0203/getPatientRecords';
export const GET_OP_REPORT = 'api/8978/getOPReport';
export const GET_PHARMACY_SALES_REPORT = 'api/0303/reports/pharmacy/salesReport';
export const GET_OP_DETAILS = 'api/9989/getOPBillingDetails';
export const GET_IP_ADMISSION_DETAIL = 'api/0207/getIPAdmissionDetail';
export const POST_IP_PHARMACY_RETURN = 'api/0207/postIPPharmacyReturn';
export const GET_PLACE = 'api/0202/getPlaceMaster';
export const POST_PLACE = 'api/0202/postPlaceMaster';

export const BATCH_STOCK = 'api/8978/getItemBatchStockReport';
export const POST_OPENING_STOCK = 'api/0303/postOpeningStock';

export const GET_PRODUCT_BATCHES = 'api/0303/getItemBatches';
export const POST_STOCK_ADJUSTMENT = 'api/0303/postStockAdjustment';
export const POST_STOCK_TRANSFER = 'api/0303/postStockTransfer';
export const GET_SALES_LOAD_DATA = 'api/0303/salesInvoiceLoad';
export const GET_INVOICE_ITEMS = 'api/0303/getSalesInvoiceItems';

export const POST_SALES_INVOICE = 'api/0303/postSalesInvoice';
export const GET_INVOICE_DETAILS = 'api/0303/getSalesInvoiceDetails';

export const POST_GENERAL_SETTINGS = 'api/0202/postGeneralSettings';
export const UPLOAD_IMG = 'api/0303/upload-image';
export const UPLOAD_URL = 'api/0202/putClientMaster';
export const GET_IMAGES = 'api/0202/getClientMaster';
export const SAVE_PRINTER = 'api/0202/postDeviceConfig';
export const GET_DEVICE_CONFIG = 'api/0202/getDeviceConfig';

export const POST_SALES_RETURN = 'api/0303/postSalesReturn';
export const POST_PURCHASE_RETURN_DRAFT = 'api/0303/postPurchaseReturnDraft';
export const GET_SALES_REPORT = 'api/0303/reports/pharmacy/salesReport';
export const GET_SALES_REPORT_WITH_ITEMS = 'api/0303/reports/pharmacy/salesReportWithItems';
export const GET_PURCHASE_REPORT_WITH_ITEMS = 'api/0303/reports/pharmacy/purchaseReportWithItems';
export const GET_PURCHASE_REPORT = 'api/0303/reports/pharmacy/purchaseReport';
export const GET_SALES_RETURN_REPORT = 'api/0303/reports/pharmacy/salesReturnReport';
export const GET_OPENING_STOCK_REPORT = 'api/0303/reports/pharmacy/openingStockReport';
export const GET_STOCK_ADJUSTMENT_REPORT = 'api/0303/reports/pharmacy/stockAdjustmentReport';
export const GET_RETURN_DRAFT = 'api/0303/getDraftlist';
export const APPROVE_RETURN = 'api/0203/postPurchaseRT';


export const GET_DOCTORS = 'api/0202/getDoctorMaster';
export const POST_DOCTOR = 'api/0202/postDoctorMaster';
export const GET_DEPARTMENTS = 'api/0202/getDepartmentMaster';
export const POST_DEPARTMENT = 'api/0202/postDepartmentMaster';


export const POST_USER = 'api/0202/postUserMaster';
export const GET_USER = 'api/0202/getUserMaster';
export const PUT_USER = 'api/0202/putUserMaster';
export const GET_USER_PERMISSIONS = 'api/0202/getUserAuthData';
export const GET_USER_AUTH_INITIAL_LOAD = 'api/0202/getUserAuthIntialLoad';
export const POST_USER_PERMISSIONS = 'api/0202/postUserPermissions';
export const DELETE_USER_MASTER = 'api/0202/deleteUserMaster';
export const GET_USER_MASTER = 'api/0202/getUserMaster';

export const GET_STOCK_CONSUMPTION_REPORT = 'api/8978/getStockAgingReport';
export const GET_EXPIRED_PRODUCT_DETAILS = 'api/8978/getExpiredProductDetails';
export const GET_INVENTORY_DEAD_STOCK = 'api/8801/getInventoryDeadStock';
export const GET_REORDER_LEVEL_REPORT = 'api/0303/reports/pharmacy/reorderLevelReport';
export const GET_ITEM_PURCHASE_HISTORY = 'api/0303/reports/pharmacy/itemPurchaseHistory';
export const GET_PURCHASE_ALL_DATA = 'api/0203/getPurchaseInvoiceDetails';
export const GET_PURCHASE_DETAILS_BY_INVOICE_NO = 'api/0203/getPurchaseDetailsByInvoiceNo';
export const GET_FOC_ITEMS_REPORT = 'api/0203/getFOCItemsReport';

export const CANCEL_SALES_ENTRY = 'api/0303/cancelSalesEntry';
export const POST_APPROVAL_ENTRY = 'api/0209/postApprovalEntry';
export const BIIL_ENTRY_LOAD = 'api/9989/getGeneralBillFormData';
export const POST_BILL_ENTRY = 'api/9989/postGeneralBillTransaction';
export const GET_GENERAL_BILLS = 'api/9989/getGeneralBills';

export const GET_BILL_HISTORY = 'api/9989/getInvoicePaymentHistory';
export const GET_PENDING_BILLS = 'api/9989/getPendingBills';
export const POST_PAYMENT = 'api/9989/postReceiptTransaction';
export const GET_RECIEPT_REPORT = 'api/8978/getReceiptDetailsSummary';
export const CANCEL_RECIEPT = 'api/9989/cancelReceiptTransaction';

export const POST_EXPENSEMASTER = 'api/0202/postExpenseCategory';
export const GET_EXPENSEMASTER = 'api/0202/getExpenseCategories';
export const POST_EXPENSEBILLING = 'api/0205/postExpenseEntry';
export const GET_EXPENSE_REPORT = 'api/0205/getExpenseEntries';
export const CANCEL_EXPENSE_ENTRY = 'api/0205/cancelExpenseEntry';

export const GET_SUBSCRIPTION_EXPIRY_DATE = 'api/0102/getSubscriptionExpiryDate';
export const GET_SECTION_WISE_REPORT = 'api/0303/reports/pharmacy/scheduleWiseReportDetails';

// Privilege Card endpoints
export const POST_PRIVILAGE_CARD_DATA = 'api/0202/postPrivilegeCardpatietMapping';
export const POST_PRIVILAGE_CARD_PRICING = 'api/0202/postPrivilegeCardPricing';
export const GET_PRIVILAGE_CARD = 'api/0202/getPrivilegeCardPricing';
export const POST_PRIVILAGE_CARD = 'api/0202/postPrivilegeCard';
export const GET_PRIVILAGE_HEAD = 'api/0202/getPrivilegeCard';
export const VALIDATE_CARD = 'api/0203/getDiscountByCardNumber';
export const STOCK_LEDGER_REPORT = 'api/0303/reports/pharmacy/closingStockReport';

export const GET_CARDS = 'api/0202/getPatientPrivilegeCards';
export const RESET_PASSWORD = 'api/0102/resetPassword';
export const DELETE_DRAFT_ITEM = 'api/0303/deletePurchaseReturnDraftItem';
export const PURCHASE_RETURN_REPORT = 'api/0303/reports/pharmacy/purchaseReturnReport';
export const POST_SHORT_BOOKS_ITEMS = 'api/0303/postShortBooksItems';
export const GET_SHORT_BOOKS_LIST = 'api/0303/getShortBooksList';
export const MARK_SHORT_BOOKS_ORDERS = 'api/0303/markShortBooksOrders';
export const GET_ITEM_MOVING_REPORT = 'api/0303/reports/pharmacy/itemWiseSoldQtyReport';


export const GET_DENOMINATIONS = 'api/0202/denominations';
export const POST_DAY_CLOSE = 'api/0202/denominations/closings';
export const GET_COLLECTION_SUMMARY ='api/0202/denominations/closings/collection-summary';

export const GET_EMR_DATA = 'api/0206/getSavedEMR';
export const GET_IP_NEXTNUM = 'api/0207/getIPDocNextNum';

export const AI_EXTRACT_BASE_URL = 'https://ai.fluxionsolution.com/';
export const EXTRACT_PURCHASE_BILL = 'extract-purchase-bill';
export const AI_EXTRACT_CLIENT_ID = '1004';
export const AI_EXTRACT_SERVICE_KEY = 'ElAgdrcD-SQQy14n7kzfuk8N3VAzpAiAbf-l5JPRR5I';